import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import ImageFreeCropper from "../crop_image/ImageFreeCropper";

function EtikEdit() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        foto: null,
        dokumen: null,
        deskripsi: "",
    });

    const [preview, setPreview] = useState({
        foto: null,
        dokumen: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    // === FETCH DATA BY ID ===
    const fetchData = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/etik/readKodeEtikById/${id}`
            );

            const data = response.data;

            setFormValue({
                foto: null,
                dokumen: null,
                deskripsi: data.deskripsi || "",
            });

            setPreview({
                foto: data.foto,
                dokumen: data.dokumen,
            });
        } catch (error) {
            Swal.fire("Error", "Gagal mengambil data", "error");
            navigate("/etik");
        }
    };

    useEffect(() => {
        fetchData();
    }, [id]);

    // === OPEN CROPPER ===
    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
        reader.readAsDataURL(file);
    };

    const closeCropper = () => {
        setCropData({ isOpen: false, imageSrc: null, imageType: "" });
    };

    // === HANDLE HASIL CROP ===
    const handleCropped = (file, previewUrl) => {
        setFormValue((prev) => ({
            ...prev,
            [cropData.imageType]: file,
        }));

        setPreview((prev) => ({
            ...prev,
            [cropData.imageType]: previewUrl,
        }));

        closeCropper();
    };

    // === HANDLE CHANGE INPUT ===
    const handleChange = (e) => {
        const { name, files, value } = e.target;

        if (files && files.length > 0) {
            const file = files[0];

            // === Dokumen wajib PDF ===
            if (name === "dokumen") {
                if (file.type !== "application/pdf") {
                    Swal.fire("Error", "Dokumen harus berupa PDF", "error");
                    return;
                }

                const url = URL.createObjectURL(file);
                setFormValue((prev) => ({ ...prev, dokumen: file }));
                setPreview((prev) => ({ ...prev, dokumen: url }));
                return;
            }

            // === Foto → wajib gambar + cropper ===
            if (name === "foto") {
                if (!file.type.startsWith("image/")) {
                    Swal.fire("Error", "File foto harus berupa gambar", "error");
                    return;
                }

                openCropper(file, "foto");
                return;
            }
        }

        // === Input text (deskripsi)
        setFormValue((prev) => ({ ...prev, [name]: value }));
    };

    // === UPDATE DATA ===
    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();

        if (formValue.foto) formData.append("foto", formValue.foto);
        if (formValue.dokumen) formData.append("dokumen", formValue.dokumen);

        formData.append("deskripsi", formValue.deskripsi);

        try {
            const token = localStorage.getItem("token");

            await axios.put(
                `${process.env.REACT_APP_API_URL}/etik/updateKodeEtik/${id}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        authorization: token,
                    },
                }
            );

            Swal.fire("Success", "Data berhasil diperbarui", "success");
            navigate("/etik");
        } catch (error) {
            Swal.fire("Error", "Gagal update data", "error");
        }
    };

    return (
        <div className="wrapper">
            <Header />
            <Navbar />

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Edit Kode Etik</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Administrasi</Link>
                                    </li>
                                    <li className="breadcrumb-item active">Edit Kode Etik</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Form Edit Kode Etik</h3>
                                    </div>

                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {/* Foto */}
                                            <div className="form-group">
                                                <label>Foto</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="foto"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview.foto && (
                                                    <img
                                                        src={preview.foto}
                                                        alt="Preview"
                                                        style={{
                                                            maxWidth: "200px",
                                                            marginTop: "10px",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                )}
                                            </div>

                                            {/* Dokumen */}
                                            <div className="form-group">
                                                <label>Dokumen (PDF)</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="dokumen"
                                                    accept="application/pdf"
                                                    onChange={handleChange}
                                                />
                                                {preview.dokumen && (
                                                    <div className="mt-2">
                                                        <p>
                                                            <b>Dokumen Saat Ini:</b>
                                                        </p>
                                                        <a
                                                            href={preview.dokumen}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-outline-info"
                                                        >
                                                            Lihat Dokumen
                                                        </a>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Deskripsi */}
                                            <div className="form-group">
                                                <label>Deskripsi</label>
                                                <textarea
                                                    className="form-control"
                                                    name="deskripsi"
                                                    rows="3"
                                                    value={formValue.deskripsi}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            {/* Tombol */}
                                            <div className="mt-3">
                                                <button type="submit" className="btn btn-info">
                                                    Update
                                                </button>
                                                <Link to="/etik">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-2"
                                                    >
                                                        Batal
                                                    </button>
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* Cropper */}
            {cropData.isOpen && (
                <ImageFreeCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={handleCropped}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default EtikEdit;
